import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgRewardsPointsHistory',
})
export default class CmgRewardsPointsHistory extends Vue {
  async mounted() {
    const countryCode = this.$appStore.state.ui.countryProfile.countryCode;
    const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();
    if (!isLoggedIn) {
      if( countryCode === 'GB' ) {
        window.location.replace(`${window.location.origin}/offers`);  
      } else {
        window.location.replace(`${window.location.origin}${this.$services.config.getRewardsPath()}`);
      }
      return;
    }
    if (!this.$services.loyalty.isLoyaltyEligible(this.$appStore.state.customer.profile)) {
      this.$router.replace({ name: Routes.Rewards });
    }
  }
}
